import React, { Fragment, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import AppContext from '../../../context/Context';

import { appName, createdBy } from '../../../config';
import ExamList from '../common/examList';

import UserCardSummary from '../common/userCardSummary';
import AdminCardSummary from '../common/adminCardSummary';

const Dashboard = () => {
  const { currentuser } = useContext(AppContext);
  const [examStatus, setExamStatus] = useState(0);
  const [examListHasChange, setExamListHasChange] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 640 && window.innerHeight > 640) {
      toast(
        <Fragment>
          Welcome to <strong>{appName}!</strong>
          <br />
          {createdBy}
        </Fragment>
      );
    }
  }, []);

  const isKiosk = currentuser.roles[0] === 'kiosk';
  const isUser = currentuser.roles[0] === 'user';

  return (
    <Fragment>
      {(isUser || isKiosk) && (
        <Fragment>
          <UserCardSummary
            status={examStatus}
            updateStatus={setExamStatus}
            listhaschange={examListHasChange}
            setListHasChange={setExamListHasChange}
            userid={currentuser.id}
          />
          <ExamList
            status={examStatus}
            updateStatus={setExamStatus}
            setListHasChange={setExamListHasChange}
            isKiosk={isKiosk}
          />
        </Fragment>
      )}
      {!isUser && !isKiosk && (
        <Fragment>
          <AdminCardSummary />
        </Fragment>
      )}
    </Fragment>
  );
};

export default Dashboard;
